import React from 'react';
import SearchComponent from './SearchComponent';
import ProcessFlowGraph from './ProcessFlowGraph';
import "./styles.css";
import { FlowProvider } from './FlowContext';
import { SearchResult } from './types';
import { useStore } from './store';
import SignInButton from './SignInButton';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import AuthWrapper from './AuthWrapper';
import Banner from './Banner';
import { useAuth } from './auth';


const MainView: React.FC = () => {
  const {
    flowID,
    optionalProcessID,
    processFlowKey,
    setFlowID,
    setOptionalProcessID,
    incrementProcessFlowKey,
    selectedYear,
    selectedMonth,
    setSelectedYear,
    setSelectedMonth, // Ensure these setters are implemented in your store
  } = useStore();

  const {initialiseLogin, isAuthenticated} = useAuth(); 

  // if not logged in begin the login process
  if (!isAuthenticated()) initialiseLogin();

  const handleVisualizeClick = () => {
    incrementProcessFlowKey();
  };

  const handleResultSelect = (result: SearchResult) => {
    setFlowID(result.FlowID[0]?.low.toString());
    setOptionalProcessID(result.ProcessID?.low.toString());
  };

  // Handler for year and month selection
  const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedYear(parseInt(event.target.value, 10));
  };

  const handleMonthChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMonth(parseInt(event.target.value, 10));
  };

  // Function to process a single year-month combination
  const processCombination = async (year: number, month: number) => {
    setSelectedYear(year);
    setSelectedMonth(month);
    // Wait for any necessary calculations or data fetching to complete
    // You might need to adjust this part based on how your store and components are set up
    await new Promise(resolve => setTimeout(resolve, 1000)); // Example delay to simulate async processing
    // Trigger any additional calculations or updates needed for this combination
  };

  // Function to iterate over all combinations
  const processAllCombinations = async () => {
    const years = [2022, 2023]; // Example years
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // All months
    for (const year of years) {
      for (const month of months) {
        await processCombination(year, month);
        console.log(`Processed ${year}-${month}`);
      }
    }
    console.log('All combinations processed');
  };

  return (

    <FlowProvider>
      <div className="layout-container">
        <Banner />
        <div className="app-container">

          <SearchComponent onResultSelect={handleResultSelect} />
          <div className="input-group">
            <input
              type="text"
              value={flowID}
              onChange={(e) => setFlowID(e.target.value)}
              placeholder="Flow ID"
            />
            <input
              type="text"
              value={optionalProcessID}
              onChange={(e) => setOptionalProcessID(e.target.value)}
              placeholder="Optional Process ID"
            />
            <button onClick={handleVisualizeClick}>Visualize Process Flow</button>
            {/* Year and Month Selectors */}
            <select
              value={`${selectedYear}-${selectedMonth.toString().padStart(2, '0')}`}
              onChange={(event) => {
                const [year, month] = event.target.value.split('-');
                setSelectedYear(parseInt(year, 10));
                setSelectedMonth(parseInt(month, 10));
              }}
              className="input-group-select" // Add this class for styling
            >
              {[...Array(5)].map((_, yearIndex) => {
                const year = new Date().getFullYear() - yearIndex;
                return [...Array(12)].map((_, monthIndex) => {
                  const month = monthIndex + 1;
                  return (
                    <option key={`${year}-${month}`} value={`${year}-${month}`}>
                      {year} - {month.toString().padStart(2, '0')}
                    </option>
                  );
                });
              })}
            </select>
            <button onClick={processAllCombinations}>Calculate Cost Breakdowns</button>

          </div>
        </div>
        <div className="graph-container">
          <ProcessFlowGraph
            key={processFlowKey}
          />
        </div>
      </div>
    </FlowProvider>
  );
};

export default MainView;
